const money = (v) => `${v < 0 ? "−" : "+"}$${Math.abs(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

const Win = ({ label, w, testid }) => (
  <div className="flex items-baseline gap-1.5 whitespace-nowrap" data-testid={testid}>
    <span className="text-[8px] uppercase tracking-[0.18em] text-[var(--r2-text2)]">{label}</span>
    {w ? (
      <>
        <span className="font-bold text-[var(--r2-text1)]">${w.symbol}</span>
        <span className="font-bold text-[#CCFF00]">{money(w.pnl_usd)}</span>
        <span className="text-[var(--r2-text2)]">{w.pnl_pct >= 0 ? "+" : ""}{w.pnl_pct.toFixed(0)}%</span>
      </>
    ) : <span className="text-[var(--r2-text2)]">—</span>}
  </div>
);

/* Live-money scoreboard (realized LIVE trades only): today's profit, biggest win today, biggest win ever. */
export const ProfitScoreboard = ({ sb }) => {
  if (!sb) return <div data-testid="profit-scoreboard" className="font-mono text-[9px] text-[var(--r2-text2)]">…</div>;
  const d = sb.day_pnl_usd || 0;
  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-1 font-mono tabular-nums text-[10px]" data-testid="profit-scoreboard">
      <div className="flex items-baseline gap-2 whitespace-nowrap">
        <span className="text-[8px] uppercase tracking-[0.18em] text-[var(--r2-text2)]">Today live</span>
        <span className={`text-[18px] font-bold leading-none ${d > 0 ? "text-[#CCFF00]" : d < 0 ? "text-[#FF5A5F]" : "text-[var(--r2-text1)]"}`} data-testid="scoreboard-day-pnl">{money(d)}</span>
        <span className="text-[var(--r2-text2)]" data-testid="scoreboard-day-trades">{sb.day_wins}/{sb.day_trades} wins</span>
      </div>
      <Win label="Best today" w={sb.best_today} testid="scoreboard-best-today" />
      <Win label="Best ever" w={sb.best_ever} testid="scoreboard-best-ever" />
    </div>
  );
};
